import { Capacitor } from '@capacitor/core';
import type { PushPlatform } from '@ste/shared';

/** true inside the iOS/Android app (Capacitor), false in the browser */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export function nativePlatform(): Extract<PushPlatform, 'ios' | 'android'> | undefined {
  const platform = Capacitor.getPlatform();
  return platform === 'ios' || platform === 'android' ? platform : undefined;
}
